import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CustomTooltipComponent } from 'src/app/components/shared/custom-tooltip/custom-tooltip.component';

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  private dialogRef: MatDialogRef<CustomTooltipComponent> | null = null;
  constructor(private dialog: MatDialog) { }

  openTooltip(event: MouseEvent, direction: string, heading: string, paragraph: string, width: number = 326, height: number = 136): void {
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    let verticalPosition = event.clientY;
    let horizontalPosition = event.clientX;
    if (direction === 'top' || direction === 'bottom') {
      horizontalPosition = event.clientX - width / 2;
    } else {
      horizontalPosition = event.clientX;
    }

    let arrowPosition = '';

    switch (direction) {
      case 'right':
        verticalPosition -= height / 2;
        horizontalPosition -= width + 20;
        arrowPosition = 'right';
        if (horizontalPosition < 0) {
          horizontalPosition = event.clientX + 20;
          arrowPosition = 'left';
        }
        break;
      case 'left':
        verticalPosition -= height / 2;
        horizontalPosition += 20;
        arrowPosition = 'left';
        if (horizontalPosition + width > viewportWidth) {
          horizontalPosition = event.clientX - width - 20;
          arrowPosition = 'right';
        }
        break;
      case 'bottom':
        verticalPosition -= height + 20;
        arrowPosition = 'bottom';
        if (verticalPosition < 0) {
          verticalPosition = event.clientY + 20;
          arrowPosition = 'top';
        }
        break;
      case 'top':
        verticalPosition += 20;
        arrowPosition = 'top';
        if (verticalPosition + height > viewportHeight) {
          verticalPosition = event.clientY - height - 20;
          arrowPosition = 'bottom';
        }
        break;
    }

    const dialogPosition = {
      top: verticalPosition + 'px',
      left: horizontalPosition + 'px',
    };

    this.dialogRef = this.dialog.open(CustomTooltipComponent, {
      width: width + 'px',
      height: height + 'px',
      position: dialogPosition,
      panelClass: 'tooltip-dialog-container',
      hasBackdrop: true,
      backdropClass: 'transparent-backdrop',
      data: {
        arrowPosition: arrowPosition,
        heading: heading,
        paragraph: paragraph,
        backgroundColor: '#027B8C',
        fontColor: '#FFFFFF',
        contentWidth: (width - 30) + 'px',
      },
    });
    window.addEventListener('resize', this.closeTooltipOnResize.bind(this));
  }

  private closeTooltipOnResize(): void {
    console.log('resize');
    if (this.dialogRef) {
      this.dialogRef.close();
      window.removeEventListener('resize', this.closeTooltipOnResize.bind(this));
    }
  }
}